export class NijisanjiSocial {
  static NijisanjiSocialList = [
    { key: "ver", value: "https://x.com/ver_vermillion" },
    { key: "maria", value: "https://x.com/mariamari0nette" },
    { key: "enna", value: "https://x.com/EnnaAlouette" },
    { key: "finana", value: "https://x.com/FinanaRyugu" },
    { key: "millie", value: "https://x.com/MillieParfait" },
    { key: "sonny", value: "https://x.com/sonny_brisko" },
  ];

  static getNijisanjiSocialValue = (key) => {
    return (
      NijisanjiSocial.NijisanjiSocialList.find((item) => item.key === key)
        ?.value ?? "Nijisanji social Not Found"
    );
  };
}
